import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";

const links = [
  { to: "/shop", label: "Shop" },
  { to: "/shop", label: "Grip Socks" },
  { to: "/grips", label: "Grip System" },
  { to: "/bundles", label: "Bundles" },
  { to: "/team-orders", label: "Team Orders" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Navbar = () => {
  const { totals, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const location = useLocation();

  React.useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="sticky top-0 z-40 border-b border-line bg-chalk/85 backdrop-blur-md"
      data-testid="site-navbar"
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <span className="wordmark text-2xl md:text-[26px] uppercase font-bold">
            Pritch
          </span>
          <span className="hidden md:inline-block subwordmark text-[10px]">Premium Pitch Wear</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l, idx) => (
            <NavLink
              key={`${l.to}-${idx}`}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[12px] tracking-[0.18em] uppercase font-medium transition-colors hover:text-ink ${
                  isActive ? "text-ink" : "text-mute"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => setOpen(true)}
            className="relative flex items-center gap-2 px-3 py-2 border border-ink hover:bg-ink hover:text-white transition-colors"
            data-testid="open-cart-button"
            aria-label="Open cart"
          >
            <ShoppingBag size={16} strokeWidth={1.5} />
            <span className="text-[11px] tracking-[0.18em] uppercase font-bold">
              Cart {totals.count > 0 && `(${totals.count})`}
            </span>
          </button>

          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            className="lg:hidden p-2 border border-ink"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden border-t border-line bg-chalk">
          <nav className="container-x flex flex-col py-4">
            {links.map((l, idx) => (
              <Link
                key={`mob-${l.to}-${idx}`}
                to={l.to}
                className="py-3 text-[13px] tracking-[0.18em] uppercase font-medium text-ink border-b border-line last:border-none"
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Navbar;
